import useSWRMutation from 'swr/mutation'
import type { Manager, ManagerId } from '@ludus/core'
import { mergeManagers } from '@/lib/api/managers.ts'
import { MANAGERS_KEY } from '@/shared/hooks/useManagers.ts'

interface MergeArg {
  keepId: ManagerId
  absorbedId: ManagerId
}

export function useMergeManagers() {
  const { trigger, isMutating } = useSWRMutation(
    MANAGERS_KEY,
    async (_key: typeof MANAGERS_KEY, { arg }: { arg: MergeArg }) => ({
      kept: await mergeManagers(arg.keepId, arg.absorbedId),
      absorbedId: arg.absorbedId,
    }),
    {
      populateCache: ({ kept, absorbedId }, current: Manager[] | undefined) =>
        (current ?? [])
          .filter((m) => m.id !== absorbedId)
          .map((m) => (m.id === kept.id ? kept : m)),
      revalidate: false,
    },
  )
  return { merge: trigger, isMutating }
}
